import { Component, forwardRef, EventEmitter, OnInit, Input, Output } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import {Message, OverlayPanel, SelectItem} from 'primeng/primeng';
import { Observable } from 'rxjs';

const noop = () => {
};

import * as ent from '../../entities/index'
import * as serv from '../../services/index'

//constants
import { Constants }         from '../../constants/Constants';

@Component({
  selector: 'my-requesttype-multiselect',
  templateUrl: './RequestTypeMultiSelect.component.html'
})
export class RequestTypeMultiSelectComponent implements OnInit {

    //The internal data model
    private innerValue: any = '';
    
    //Placeholders for the callbacks which are later providesd
    //by the Control Value Accessor
    private onTouchedCallback: () => void = noop;
    private onChangeCallback: (_: any) => void = noop;

    //get accessor
    get value(): any {
        return this.innerValue;
    };

    //set accessor including call the onchange callback
    set value(v: any) {
        if (v !== this.innerValue) {
            this.innerValue = v;
            this.valueChange.emit(v);
            this.onChangeCallback(v);
        }
    }

    //Set touched on blur
    onBlur() {
        this.onTouchedCallback();
    }

    //From ControlValueAccessor interface
    writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }

    //From ControlValueAccessor interface
    registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }

    //From ControlValueAccessor interface
    registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }

    @Input() public selectedIDs: number[] = [];
    @Output() public valueChange: EventEmitter<number> = new EventEmitter();
    IDsToSelectOnLoad: number[] = [];
    
    public selectItems: SelectItem[] = [];
    requestTypes: ent.RequestType[] = [];

    constructor(private domainDataService: serv.DomainDataService) 
    { 
    }


    ngOnInit(): void {
        //this.load();
    }

    public load(): Observable<any>{

        return new Observable((observer) => { 
            this.domainDataService.getRequestTypes().subscribe(x=> {
                //this.selectItems.push({label:"", value:Constants._NONE});
                x.forEach(y=> this.selectItems.push({label:y.Name, value:y.ID}));
                x.forEach(y=> this.requestTypes.push(y));
    
                if (this.IDsToSelectOnLoad){
                    for (var id of this.IDsToSelectOnLoad){
                        this.selectedIDs.push(id);
                    }
                }
                observer.next(x);
                observer.complete();
            });
        });
        
    }
    
}